<template>
  <div class="thin-teacher-info">
    <div class="left">
      <img v-lazy-load class="teacher-img" height="324" v-lazy-load :data-src="`${teacher.avatar}?im=Resize=(560,560)`" :alt="teacher.name">
    </div>
    <div class="right">
      <div class="teacher-name">
        {{ teacher.name }}
      </div>
      <div class="text-overflow-ellipsis-2 teacher-subject" :title="teacher.education">
        {{ teacher.education }}
      </div>
    </div>
    <div class="teacher-tags-list">
      <div v-for="(tag, tagIndex) in teacher.highlightList.slice(0,3)" :key="tagIndex" class="tag-item text-overflow-ellipsis" :title="tag">
        {{ tag }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    teacher: {
      default: () => ({}),
      type: Object,
    },
  },
  mounted() {
    this.teacherCardShow()
  },
  methods: {
    teacherCardShow() {
      const currRoute = this.$route.name
      if (currRoute !== 'teachers') {
        return
      }
      this.Sensors.track('teacher_card_show', {
        content_teacher: this.teacher.name,
        teacher_card_type: '小卡',
        previous_source: 'our teachers',
      })
    },
  },
}

</script>
<style lang="scss" scoped>
.thin-teacher-info {
  border-radius: 10px;
  display: flex;
  align-items: center;

  .left {
    width: 70px;
    height: 70px;
    background: #fff;

    img {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      display: block;
    }

    border-radius: 10px;
  }

  .right {
    padding: 0 20px;
    width: 310px;
    overflow: hidden;

    .teacher-name {
      font-size: 24px;
      font-weight: 600;
      color: var(--txt-color-lv1);
      line-height: 29px;
    }

    .teacher-subject {
      font-size: 18px;
      margin: 8px 0;
      font-weight: 600;
      color: var(--txt-color-lv3);
      line-height: 21px;

      &:nth-child(3) {
        margin-top: 0;
      }
    }
  }

  .teacher-tags-list {
    flex-grow: 1;
    text-align: right;

    .tag-item {
      // max-width: 260px;
      width: fit-content;
      display: inline-block;
      flex-shrink: 0;
      margin-bottom: 16px;
      margin-right: 10px;
      padding: 12px 20px;
      background: var(--txt-color-link3);
      border-radius: 100px;
      box-sizing: border-box;
      font-size: 16px;
      font-weight: 500;
      color: var(--txt-color-link);
      line-height: 19px;

      .iconfont {
        margin-right: 6px;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
